/**
 * モーダル表示
 *
 * Author : Tomida Takeshi <tomida@linkainc.jp>
 * Company : LINKA ASSOCIATES INC.
 * Copyright : Copyright(c) 2019 LINKA ASSOCIATES INC.
 * Create : 2018.02
 * module : jquery
 */
import $ from 'jquery';
import './styles.scss';

export default class{
  constructor(params){
    this.settings = Object.assign({},this.defaults(),params);
  }

  defaults(){
    return{
      target : 'body',
      modalId : 'js-modal',
      el : '',
      activeClass : 'active',
      overlayClose: true,
      closeClass: 'modal-close',
      closeText: '',
      closeAfterFunc: null,
      renderClose: true,
    }
  }

  setHtml(html){
    this.settings.el = html;
    return this
  }

  show(){
    this.settings.scrPos = $( window ).scrollTop();
    const baseDom = this.createHtml();
    this.settings.createDom = baseDom;
    $('#'+this.settings.modalId).remove();
    $(this.settings.target).append(baseDom);
    setTimeout(()=>{
      baseDom.addClass(this.settings.activeClass);
      $('html').addClass('fixed');
    },100);

    baseDom.find(`.${this.settings.closeClass}`).on('click',()=>{
      this.close();
    })
    if(this.settings.overlayClose){
      baseDom.find('.modal-overlay').on('click',() => {
        this.close();
      })
    }
  }

  close(){
    $('html, body').prop({scrollTop: this.settings.scrPos});
    this.settings.createDom.removeClass(this.settings.activeClass);
    $('html').removeClass('fixed');
    if(this.settings.closeAfterFunc){
      this.settings.closeAfterFunc()
    }
  }

  createHtml(){
    const baseHtml = '<div id="'+this.settings.modalId+'"><div class="modal-overlay"></div><div class="modal-content-wrap"><div class="modal-content">'+this.settings.el+'</div></div></div>';
    const baseDom = $(baseHtml);
    if(this.settings.renderClose){
      baseDom.find('.modal-content-wrap').append('<div class="modal-close">'+this.settings.closeText+'</div>');
    }
    return baseDom;
  }
}
